import { T } from '@territory/tokens';
import { TOUCH_MIN } from '../scale.js';

/* Released header radius, off-scale. */
const MENU_RADIUS = 11;

/* The released public header menu. Native padding, glyphs and pointer paint stay unchanged. */
export function marketingMenuCss(sel: string): string {
  return `${sel} { display: flex; align-items: center; justify-content: center; width: ${TOUCH_MIN}px; height: ${TOUCH_MIN}px; border-radius: ${MENU_RADIUS}px; background: var(--rv-s1, ${T.surfaceAlt}); border: 1px solid var(--rv-border, ${T.separator}); color: var(--rv-text, ${T.label}); cursor: pointer; }
${sel}:focus-visible { outline: 2px solid ${T.accent}; outline-offset: 3px; }`;
}
